/**
 * Intenta extraer latitud y longitud WGS84 desde URLs típicas de Google Maps
 * (pegar enlace al compartir o al copiar desde la barra de direcciones).
 *
 * No resuelve acortadores tipo goo.gl / maps.app.goo.gl sin seguir la redirección.
 */

function parseCoordPair(a: string, b: string): { lat: number; lng: number } | null {
  const lat = parseFloat(String(a).replace(',', '.'));
  const lng = parseFloat(String(b).replace(',', '.'));
  if (Number.isNaN(lat) || Number.isNaN(lng)) return null;
  if (lat < -90 || lat > 90 || lng < -180 || lng > 180) return null;
  return { lat, lng };
}

const NUM = '-?\\d+(?:[.,]\\d+)?';

export function parseLatLngFromGoogleMapsUrl(raw: string): { lat: number; lng: number } | null {
  const url = raw.trim();
  if (!url) return null;

  let decoded = url;
  try {
    decoded = decodeURIComponent(url);
  } catch {
    /* usar url tal cual */
  }

  // Formato !3d28.12!4d-15.53 en URLs recientes
  const bangMatch = decoded.match(new RegExp(`!3d(${NUM})!4d(${NUM})`, 'i'));
  if (bangMatch) {
    const p = parseCoordPair(bangMatch[1], bangMatch[2]);
    if (p) return p;
  }

  // ?q=lat,lng o &q=lat,lng
  const qMatch = decoded.match(new RegExp(`[?&]q=(${NUM}),(${NUM})`, 'i'));
  if (qMatch) {
    const p = parseCoordPair(qMatch[1], qMatch[2]);
    if (p) return p;
  }

  // /@lat,lng,zoom
  const atMatch = decoded.match(new RegExp(`@(${NUM}),(${NUM})(?:,|\\s|$)`));
  if (atMatch) {
    const p = parseCoordPair(atMatch[1], atMatch[2]);
    if (p) return p;
  }

  // ?ll=lat,lng
  const llMatch = decoded.match(new RegExp(`[?&]ll=(${NUM}),(${NUM})`, 'i'));
  if (llMatch) {
    const p = parseCoordPair(llMatch[1], llMatch[2]);
    if (p) return p;
  }

  // center=lat,lng
  const centerMatch = decoded.match(new RegExp(`[?&]center=(${NUM}),(${NUM})`, 'i'));
  if (centerMatch) {
    const p = parseCoordPair(centerMatch[1], centerMatch[2]);
    if (p) return p;
  }

  return null;
}

export function isLikelyMapsShortUrl(url: string): boolean {
  const u = url.trim().toLowerCase();
  if (!u) return false;
  if (u.includes('goo.gl/maps') || u.includes('maps.app.goo.gl')) return true;
  return false;
}

/** Enlace que el propio parser entiende (`?q=lat,lng`), útil para rellenar el campo al editar. */
export function buildGoogleMapsLinkFromCoords(
  lat: number | null | undefined,
  lng: number | null | undefined
): string {
  if (lat == null || lng == null || Number.isNaN(lat) || Number.isNaN(lng)) return '';
  if (lat < -90 || lat > 90 || lng < -180 || lng > 180) return '';
  const r = (n: number) => Math.round(n * 1e6) / 1e6;
  return `https://www.google.com/maps?q=${r(lat)},${r(lng)}`;
}
